/**
 * Ryan O'Dowd
 * 2024-10-02
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors}) => {
  return {
    container: {
      minWidth: 500,
    },
    logoFormControl: {
      padding: globalScale * 8, // @TODO: shouldn't have to do this for all form controls that aren't wrapping textinput or select
      paddingTop: globalScale * 12, // @TODO: shouldn't have to do this for all form controls that aren't wrapping textinput or select
      flexDirection: 'row',
      alignItems: 'center',
    },
    schoolLogoImage: {
      display: 'flex',
      width: 60,
      height: 60,
      aspectRatio: 1,
      borderRadius: globalScale * 8,
      borderColor: colors.primaryLight, // @TODO: different if premium?
      borderWidth: globalScale * 2,
      marginRight: globalScale * 8,
    },
    addressFormControl: {
      padding: globalScale * 8,
      flexDirection: 'column',
    },
    addressRow: {
      flexDirection: 'row',
      gap: globalScale * 4,
    },
    cardInfoFormControl: {
      padding: globalScale * 8, // @TODO: shouldn't have to do this for all form controls that aren't wrapping textinput or select
      paddingTop: globalScale * 12, // @TODO: shouldn't have to do this for all form controls that aren't wrapping textinput or select
      alignItems: 'flex-start',
      justifyContent: 'space-between',
    },
    cardInfoWrapper: {
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: globalScale * 8,
    },
    ccImageAndExpiration: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: globalScale * 4,
      marginBottom: globalScale * 4,
    },
    ccImage: {
      width: 64,
      aspectRatio: 1.56,
      objectFit: 'contain',
    },
    expirationText: {
      fontSize: globalScale * 12,
      // @TODO: if expired, make it red
    },
    buttonAndMessages: {
      flexDirection: 'column',
      alignItems: 'flex-end',
    },
    paymentSuccessText: {
      color: colors.accentDark,
    },
    paymentCanceledText: {
      color: colors.alert,
    },
  };
};

export default getStyles;
